import { Injectable } from '@angular/core';

export interface ErrorItem {
  mensaje: string;
  field: string;
}

@Injectable({
  providedIn: 'root'
})

export class ErrorTrackingService {

  private errors: ErrorItem[] = [];
  private currentErrorIndex: number = 0;

  constructor() { }

  setErrors(errors: ErrorItem[]) {
    this.errors = errors;
    this.currentErrorIndex = 0;
  }

  getCantidadErrores() {
    return this.errors.length;
  }

  getCurrentError() {
    return this.currentErrorIndex;
  }

  getCurrentErrorItem(): ErrorItem {
    return this.errors[this.currentErrorIndex];
  }

  previousError() {
    if (this.currentErrorIndex > 0) {
      this.currentErrorIndex--;
      this.focoErrorActual();
    }
  }

  nextError() {
    if (!this.esUltimoError()) {
      this.currentErrorIndex++;
      this.focoErrorActual();
    }
  }

  esPrimerError(): boolean {
    return this.currentErrorIndex == 0;
  }

  esUltimoError(): boolean {
    return this.currentErrorIndex == this.errors.length - 1;
  }

  esErrorActual(field: string): boolean {
    if (!this.errors) return false;
    let errorActual = this.getCurrentErrorItem();
    return errorActual && errorActual.field == field;
  }

  focoPrimerError() {
    if (this.errors && this.errors.length > 0) {
      this.currentErrorIndex = 0;
      this.focoErrorActual();
    }
  }

  focoErrorActual() {
    let errorActual = this.getCurrentErrorItem();
    this.focoError(errorActual);
  }

  focoError(error: ErrorItem) {
   // debugger
    const field = error.field;
    const element = document.getElementById(field);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
